import { match } from 'ts-pattern';
import { z } from 'zod';

export const tabValueSchema = z.enum(['bodyPart', 'division', 'tag']);
export type TabValue = z.infer<typeof tabValueSchema>;

export const bodyPartCodeSchema = z.enum([
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
]);
export type BodyPartCode = z.infer<typeof bodyPartCodeSchema>;

export const BODY_PART_DEFAULT: BodyPartCode = '01';
const DIV_CODE_DEFAULT = '00';

export type GalleryTabsFilter = {
  bodyPartCode: string;
  divCode: string;
  tagNameList: string[];
};

export const applyTabDefaults = (
  filter: GalleryTabsFilter,
  activeTab: TabValue,
): GalleryTabsFilter =>
  match(activeTab)
    .with('bodyPart', () => ({
      bodyPartCode: filter.bodyPartCode || BODY_PART_DEFAULT,
      divCode: '',
      tagNameList: [],
    }))
    .with('division', () => ({
      bodyPartCode: '',
      divCode: filter.divCode || DIV_CODE_DEFAULT,
      tagNameList: [],
    }))
    .with('tag', () => ({
      bodyPartCode: '',
      divCode: '',
      tagNameList: filter.tagNameList,
    }))
    .exhaustive();

export const gallerySearchParams = z
  .object({
    bodyPartCode: z.string().optional().default(''),
    divCode: z.string().optional().default(''),
    tagNameList: z.array(z.string()).optional().default([]),
    search: z.string().optional().default(''),
    activeTab: tabValueSchema.optional().default('bodyPart'),
  })
  .transform((data) => ({
    ...data,
    ...applyTabDefaults(data, data.activeTab),
  }));

export type GallerySearchParams = z.infer<typeof gallerySearchParams>;

export const GALLERY_SEARCH_PARAMS_DEFAULTS: GallerySearchParams =
  gallerySearchParams.parse({});
